// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1kLEX","footer":"Form_footer__2m9Hl"};